import Filters from '@nematis/hooks/lib/filters'
import {
  createHooks
} from '@wordpress/hooks'

// initialize hooks system once for the whole website
window[Filters.getHooksInstanceName()] = createHooks()
